import { Smush } from "../../../types/helpers";
import { Product } from "../../../types/types";

export const generateDeliveryOptions = (product: Smush<Product>) => {
  const allDeliveryGroups = product.fulfilmentOptions?.available?.map(
    (fulfilmentOption) => fulfilmentOption.deliveryGroupId.toLowerCase(),
  );
  const uniqueDeliveryGroups = [...new Set(allDeliveryGroups)];
  return uniqueDeliveryGroups.join("|");
};
